"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const timeOutResponseFactory_1 = __importDefault(require("./Response/timeOutResponseFactory"));
const cache_1 = require("@almservices-cl/cache");
const exception_1 = require("@almservices-cl/exception");
class CLConnectMock {
    constructor() {
        this.logIn = timeOutResponseFactory_1.default;
        this.refreshToken = timeOutResponseFactory_1.default;
        this.requestPasswordChange = timeOutResponseFactory_1.default;
        this.changePassword = timeOutResponseFactory_1.default;
        this.after = timeOutResponseFactory_1.default;
        this.before = timeOutResponseFactory_1.default;
        this.send = timeOutResponseFactory_1.default;
        this.getCapacity = timeOutResponseFactory_1.default;
        this.setCapacity = timeOutResponseFactory_1.default;
        this.getPersonalInformation = timeOutResponseFactory_1.default;
        this.getRatings = timeOutResponseFactory_1.default;
        this.getCalorieBudget = timeOutResponseFactory_1.default;
        this.setCalorieBudgets = timeOutResponseFactory_1.default;
        this.getFoodPreferences = timeOutResponseFactory_1.default;
        this.getCustomers = timeOutResponseFactory_1.default;
        this.getCustomer = timeOutResponseFactory_1.default;
        this.markCustomerAsRead = timeOutResponseFactory_1.default;
        this.getLatestIntakeInfo = timeOutResponseFactory_1.default;
        this.getCustomerNote = timeOutResponseFactory_1.default;
        this.setCustomerNote = timeOutResponseFactory_1.default;
        this.getCustomerNotifications = timeOutResponseFactory_1.default;
        this.getTrainingsPerWeek = timeOutResponseFactory_1.default;
        this.getAvailableEnvironments = () => {
            const environmentObservable = new cache_1.Observable("environment");
            environmentObservable.setError(new exception_1.NetworkException("Request timed out"));
            return environmentObservable;
        };
        this.getNutritionProgressByDate = timeOutResponseFactory_1.default;
        this.getNutritionProgressByDateRange = timeOutResponseFactory_1.default;
        this.getDateRange = timeOutResponseFactory_1.default;
        this.getDate = timeOutResponseFactory_1.default;
        this.getRange = timeOutResponseFactory_1.default;
        this.getMeasurements = timeOutResponseFactory_1.default;
        this.fetch = timeOutResponseFactory_1.default;
        this.changeCoachingDay = timeOutResponseFactory_1.default;
        this.getCustomerSubscriptions = timeOutResponseFactory_1.default;
        this.getDayType = timeOutResponseFactory_1.default;
        this.fetchCalorieBudgets = timeOutResponseFactory_1.default;
        this.getMeasurementInfo = timeOutResponseFactory_1.default;
        this.sendAttachment = timeOutResponseFactory_1.default;
        this.getMembersList = timeOutResponseFactory_1.default;
        this.getHistory = timeOutResponseFactory_1.default;
        this.getHistoryAfter = timeOutResponseFactory_1.default;
        this.fetchSportActivities = timeOutResponseFactory_1.default;
        this.fetchSportActivitiesPerDate = timeOutResponseFactory_1.default;
        this.getMonthlyCustomerOverview = timeOutResponseFactory_1.default;
        this.getCustomerActions = timeOutResponseFactory_1.default;
        this.dismissCustomerAction = timeOutResponseFactory_1.default;
        this.fetchNutritionProgressByDateRange = timeOutResponseFactory_1.default;
    }
}
exports.default = CLConnectMock;
//# sourceMappingURL=CLConnectMock.js.map